import React, { createContext, useState, useContext, useEffect } from 'react';

const SelfServiceLanguageContext = createContext();

// Translations for self-service mode
const translations = {
    ru: {
        scanBarcode: 'Отсканируйте\nштрихкод',
        orPressButton: 'Или нажмите кнопку ниже, что-бы начать покупку',
        startPurchase: 'Начать покупку',
        scanHere: 'Сканируйте\nздесь',
        enterBarcode: 'Ввести штрихкод',
        yourPurchases: 'Ваши покупки',
        addPackage: 'Добавить пакет',
        total: 'Итого',
        proceedToPayment: 'Перейти к оплате',
        purchaseAmount: 'Стоимость покупок',
        applyCardOrScanQR: 'Приложите карту\nили отсканируйте QR-код',
        applyCard: 'Приложите\nкарту',
        scanLoyaltyCard: 'Отсканируйте карту лояльности',
        thankYouForPurchase: 'Спасибо\nза покупку!',
        fiscalReceipt: 'Фискальный чек',
        startNewPurchase: 'Начнём новую покупку через',
        startNewPurchaseButton: 'Начать новую покупку',
        seconds: 'сек.',
        ageVerificationTitle: 'Отсканируйте штрихкод\nна удостоверении личности',
        ageVerificationText: 'Без проверки возраста нельзя добавить товар\nс возрастным ограничением – это\nтребование закона',
        ageVerificationBefore: 'Перед оплатой к вам подойдет сотрудник магазина,\nчтобы проверить возраст. Подготовьте документы',
        markingCodeTitle: 'Отсканируйте код маркировки',
        markingCodeText: 'Без кода нельзя добавить маркированный\nтовар в чек – это требование закона',
        points: 'баллов',
        usePoints: 'Использовать баллы',
        youHave: 'У вас',
        spendBonus: 'Потратить бонусы',
        minimarket: 'миниМаркет',
        russian: 'Русский',
        kazakh: 'Қазақша',
        english: 'English',
        paymentSuccess: 'Оплата прошла',
        paymentFailed: 'Оплата не прошла',
        goBack: 'Вернуться назад',
        paymentError: 'Ошибка оплаты'
    },
    kz: {
        scanBarcode: 'Штрих-кодты\nсканерлеңіз',
        orPressButton: 'Немесе сатып алуды бастау үшін төмендегі түймені басыңыз',
        startPurchase: 'Сатып алуды бастау',
        scanHere: 'Осында\nсканерлеңіз',
        enterBarcode: 'Штрих-кодты енгізу',
        yourPurchases: 'Сатып алулар',
        addPackage: 'Қап қосу',
        total: 'Барлығы',
        proceedToPayment: 'Төлемге өту',
        purchaseAmount: 'Сатып алу құны',
        applyCardOrScanQR: 'Картаны қойыңыз\nнемесе QR-кодты сканерлеңіз',
        applyCard: 'Картаны\nқойыңыз',
        scanLoyaltyCard: 'Адалдық картасын сканерлеңіз',
        thankYouForPurchase: 'Сатып алғаныңыз\nүшін рахмет!',
        fiscalReceipt: 'Фискалды чек',
        startNewPurchase: 'Жаңа сатып алуды бастаймыз',
        startNewPurchaseButton: 'Жаңа сатып алуды бастау',
        seconds: 'сек.',
        ageVerificationTitle: 'Жеке куәліктегі\nштрих-кодты сканерлеңіз',
        ageVerificationText: 'Жасты тексермей жасқа қатысты шектеулі тауарды\nқосуға болмайды – бұл заңның талабы',
        ageVerificationBefore: 'Төлем алдында дүкен қызметкері жасыңызды тексеру үшін келеді.\nҚұжаттарды дайындаңыз',
        markingCodeTitle: 'Маркалау кодын сканерлеңіз',
        markingCodeText: 'Кодсыз маркаланған тауарды чекке\nқосуға болмайды – бұл заңның талабы',
        points: 'ұпай',
        usePoints: 'Ұпайларды пайдалану',
        youHave: 'Сізде',
        spendBonus: 'Бонустарды жұмсау',
        minimarket: 'миниМаркет',
        russian: 'Русский',
        kazakh: 'Қазақша',
        english: 'English',
        paymentSuccess: 'Төлем өтті',
        paymentFailed: 'Төлем өтпеді',
        goBack: 'Артқа қайту',
        paymentError: 'Төлем қатесі'
    },
    en: {
        scanBarcode: 'Scan\nbarcode',
        orPressButton: 'Or press the button below to start shopping',
        startPurchase: 'Start shopping',
        scanHere: 'Scan\nhere',
        enterBarcode: 'Enter barcode',
        yourPurchases: 'Your purchases',
        addPackage: 'Add package',
        total: 'Total',
        proceedToPayment: 'Proceed to payment',
        purchaseAmount: 'Purchase amount',
        applyCardOrScanQR: 'Apply card\nor scan QR code',
        applyCard: 'Apply\ncard',
        scanLoyaltyCard: 'Scan loyalty card',
        thankYouForPurchase: 'Thank you\nfor your purchase!',
        fiscalReceipt: 'Fiscal receipt',
        startNewPurchase: 'Starting new purchase in',
        startNewPurchaseButton: 'Start new purchase',
        seconds: 'sec.',
        ageVerificationTitle: 'Scan the barcode\non your ID',
        ageVerificationText: 'Without age verification, you cannot add\nage-restricted items – this is required by law',
        ageVerificationBefore: 'A store employee will verify your age before payment.\nPrepare your documents',
        markingCodeTitle: 'Scan marking code',
        markingCodeText: 'Without a code, you cannot add marked items\nto the receipt – this is required by law',
        points: 'points',
        usePoints: 'Use points',
        youHave: 'You have',
        spendBonus: 'Spend bonus',
        minimarket: 'miniMarket',
        russian: 'Русский',
        kazakh: 'Қазақша',
        english: 'English',
        paymentSuccess: 'Payment successful',
        paymentFailed: 'Payment failed',
        goBack: 'Go back',
        paymentError: 'Payment error'
    }
};

export const SelfServiceLanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        // Load from localStorage or default to Russian
        return localStorage.getItem('self_service_language') || 'ru';
    });

    useEffect(() => {
        // Save to localStorage when language changes
        localStorage.setItem('self_service_language', language);
    }, [language]);

    const t = (key) => {
        return translations[language][key] || key;
    };

    const value = {
        language,
        setLanguage,
        t,
        translations: translations[language]
    };

    return (
        <SelfServiceLanguageContext.Provider value={value}>
            {children}
        </SelfServiceLanguageContext.Provider>
    );
};

export const useSelfServiceLanguage = () => {
    const context = useContext(SelfServiceLanguageContext);
    if (!context) {
        throw new Error('useSelfServiceLanguage must be used within SelfServiceLanguageProvider');
    }
    return context;
};
